jQuery(function($) {
//     $('.spb-productoptiontextcolor').click(function(){
//       console.log("check");
//       $('.mono-text-fields').toggleClass("active");
//     });
  
    $(document).on("click",".add-monogram input",function(){
      console.log("check");
      $('input[name="properties[Monogram]"]').remove();
      $(document).find('.mono-text-fields').toggleClass("active");
    });
  

});

// document.getElementsByClassName('spb-productoptiontextcolor').onclick  = addClass();
// function addClass() { 
//   var v = document.getElementsByClassName ("mono-text-fields"); 
//   v.className += "active"; 
// }